import script from "./MemberGalleryPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberGalleryPublic.vue?vue&type=script&setup=true&lang=js"

import "./MemberGalleryPublic.vue?vue&type=style&index=0&id=69c10653&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69c10653"]])

export default __exports__